import React from 'react';

import './header.scss';

const Header = () => {
	return (
		<header>
			<div className='header'>ToDo List</div>
		</header>
	);
};

export default Header;
